module.exports = __webpack_public_path__ + "static/media/thumbnail.e04d8a77.jpg";